import { all, fork } from 'redux-saga/effects';

import authoritySaga from './authority/sagas';

export default function* userSagas() {
  yield all([fork(authoritySaga)]);
}
